import { BodyMedium, HeadingXLarge, theme } from '@arnold/common';
import { ReactComponent as LogoInBubble } from '@arnold/common/lib/assets/logo/LogoInBubble.svg';
import { ReactComponent as LogoPrimary } from '@arnold/common/lib/assets/logo/LogoPrimaryDarkBkg.svg';
import styled from '@emotion/styled';
import { Trans, useTranslation } from 'react-i18next';
import {
  HeadingContainer,
  HideOnMobile,
  LogoContainer,
  LogoWithHeadingContainer,
  RegistrationAsideContent,
} from '../../components/StyledComponents';

const AsideTermsLink = styled.a`
  color: ${theme.colors.textInverted.primary};
  font-weight: 700;
  text-decoration: none;

  &:hover,
  &:visited:hover {
    color: ${theme.colors.textInverted.secondary};
    text-decoration: none;
  }

  &:visited {
    color: ${theme.colors.textInverted.primary};
  }
`;

const ShowMoreContainer = styled.div`
  padding: ${theme.spacing.h} 0 0 0;

  @media (min-width: ${theme.breakpoint.small}) {
    padding: ${theme.spacing.g} 0;
  }

  @media (max-width: ${theme.breakpoint.small}) {
    margin: 0 0 ${theme.spacing.h};
  }
`;

const LoginWithInfoAside = () => {
  const { t } = useTranslation('loginForm');
  return (
    <RegistrationAsideContent>
      <LogoWithHeadingContainer>
        <LogoInBubble />
        <HeadingContainer>
          <HeadingXLarge color={theme.colors.textInverted.primary} margin={'0'}>
            {t('loginToArnold')}
          </HeadingXLarge>
        </HeadingContainer>
        <BodyMedium color={theme.colors.textInverted.primary}>
          <Trans
            i18nKey={'loginForm:loginTermsNotice'}
            components={[<AsideTermsLink href={t('registration:T&CLink')} target="_blank" rel="noreferrer" />]}
          />
        </BodyMedium>
        <HideOnMobile>
          <BodyMedium color={theme.colors.textInverted.primary}>
            <Trans i18nKey={'loginForm:asideDescription'} components={[<strong />]} />
          </BodyMedium>
          <ShowMoreContainer>
            <BodyMedium color={theme.colors.textInverted.primary}>
              <ul>
                <li>
                  <Trans i18nKey={'loginForm:asideItem1'} components={[<strong />, <strong />]} />
                </li>
                <li>
                  <Trans i18nKey={'loginForm:asideItem2'} components={[<strong />]} />
                </li>
              </ul>
            </BodyMedium>
          </ShowMoreContainer>
        </HideOnMobile>
      </LogoWithHeadingContainer>
      <LogoContainer>
        <LogoPrimary width="228" height="57" />
      </LogoContainer>
    </RegistrationAsideContent>
  );
};

export default LoginWithInfoAside;
